import { FC, useEffect } from 'react';
import { css } from '@emotion/react';
import { AnalyticsUtils } from '@frontend/analytics-shared';
import { BarChartAppearance } from '@frontend/charts';
import { useFetchAggregatedAppointmentsData } from '../hooks/use-fetch-aggregated-appointments-data';
import { AppointmentsCountChart } from './charts/appointments-count-chart';
import { AppointmentsPatientsTypeChart } from './charts/appointments-patients-type-chart';
import { AppointmentsPmsStatusChart } from './charts/appointments-pms-status-chart';
import { AppointmentsWeaveStatusChart } from './charts/appointments-weave-status-chart';

interface Props {
  onFetchStateChange: (isFetching: boolean) => void;
}

const commonChartAppearanceProps: BarChartAppearance = {
  collectiveTooltip: true,
  showGridLines: true,
  showXAxis: true,
  showYAxis: true,
};

export const AppointmentChartsView: FC<React.PropsWithChildren<Props>> = ({ onFetchStateChange }) => {
  const { data, isLoading } = useFetchAggregatedAppointmentsData({
    dateRangeMap: AnalyticsUtils.defaultDateRangeMap,
  });

  useEffect(() => {
    onFetchStateChange(isLoading);
  }, [isLoading]);

  const commonProps = {
    appearance: commonChartAppearanceProps,
    data,
    isLoading,
  };

  return (
    <div css={styles.wrapper}>
      <AppointmentsCountChart {...commonProps} />
      <AppointmentsPmsStatusChart {...commonProps} />
      <AppointmentsWeaveStatusChart {...commonProps} />
      <AppointmentsPatientsTypeChart {...commonProps} />
    </div>
  );
};

const styles = {
  wrapper: css`
    height: 100%;
    overflow: auto;
  `,
};
